import React, { useEffect, useState } from 'react'

import { SwiperProps } from '../types/custom-swiper.types'

import { useSwiperAutoplay } from './useAutoPlay'
import { useSwiperNavigation } from './useSwiperNavigation'

export function useCustomSwiper(props: SwiperProps) {
  const {
    numberOfVisibleSlides,
    children,
    isVertical,
    afterChange,
    spaceBetween,
    autoplay = false,
    disableSwipe = false,
    autoplaySpeed = 3000,
    initialSlide,
  } = props

  const { containerRef, activeIndex, isBeginning, isEnd, scrollToNext, scrollToPrev, handleScroll } =
    useSwiperNavigation({
      numberOfVisibleSlides,
      childrenCount: React.Children.count(children),
      spaceBetween,
      isVertical,
      afterChange,
      initialSlide,
    })

  useSwiperAutoplay({ autoplay, disableSwipe, scrollToNext, autoplaySpeed })

  const [totalSlides, setTotalSlides] = useState(0)
  const childrenLen = React.Children.toArray(children).length

  useEffect(() => {
    setTotalSlides(childrenLen)
  }, [childrenLen])

  const canNavigate = numberOfVisibleSlides ?? 0 < totalSlides

  return {
    containerRef,
    activeIndex,
    isBeginning,
    isEnd,
    scrollToNext,
    scrollToPrev,
    canNavigate,
    totalSlides,
    handleScroll,
  }
}
